export default __webpack_public_path__ + "static/media/NSIN.bb91161a.svg";